export default "__VITE_ASSET__DvnCKvtk__"